module.exports = __webpack_public_path__ + "static/media/logo.7d2d9ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/nav/logo.png
// module id = 1336
// module chunks = 0